import React, { useState } from "react";
import sendMessageForDistributor from "../api/sendMessageForDistributor";

const DistributorSendMessagePop = ({ distributor, toggleSendMessagePop }) => {
    const [message, setMessage] = useState("");
    const [sendMessageStatus, setSendMessageStatus] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState(false);
    const [messageDisplayResponse, setMessageDisplayResponse] = useState("");

    // handle Change Status
    const handleSendMessage = async (e) => {
        e.preventDefault();
        const response = await sendMessageForDistributor({
            userid: distributor.id,
            token: distributor.notification,
            content: message,
        });
        if (response) {
            setMessageDisplayResponse("ثم إرسال الرسالة الى العميل");
            setMessageSuccess(true);
            setSendMessageStatus(true);
        } else {
            setMessageDisplayResponse("حدث  خطا إثناء إرسال الرسالة");
            setMessageSuccess(false);
            setSendMessageStatus(true);
        }

        setTimeout(() => {
            setSendMessageStatus(false);
        }, 2000);
    };
    return (
        <>
            <div className="fixed w-[45%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 shadow-lg rounded-lg  border z-10">
                <button
                    className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
                    onClick={() => toggleSendMessagePop()}
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 18L18 6M6 6l12 12"
                        ></path>
                    </svg>
                </button>
                <div className="my-2">
                    <h2 className="text-xl mb-4">
                        <span> إرسال رسالة للعميل</span>-(
                        <span className="mx-2">{distributor.name}</span>)
                    </h2>
                    <form className="flex flex-col items-end my-2" onSubmit={handleSendMessage}>
                        <div className="mb-2 w-full text-right">
                            <label className="block mb-2 text-md">نص الرسالة </label>
                            <textarea
                                className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
                                name="message"
                                rows={4}
                                cols={80}
                                dir="rtl"
                                value={message}
                                onChange={(e) => {
                                    setMessage(e.target.value);
                                }}
                            />
                        </div>
                        {sendMessageStatus ? (
                            messageSuccess ? (
                                <p className="w-full font-bold text-lg text-green-500 mb-2 flex items-center justify-center">
                                    {messageDisplayResponse}
                                </p>
                            ) : (
                                <p className="w-full font-bold text-lg text-red-500 mb-2 flex items-center justify-center">
                                    {messageDisplayResponse}
                                </p>
                            )
                        ) : (
                            ""
                        )}
                        <button
                            type="submit"
                            className="bg-blue-500 text-white px-4 py-2 rounded-lg"
                        >
                            إرسال الرسالة
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default DistributorSendMessagePop;
